module.exports = __webpack_public_path__ + "img/sv.1f2e7466.svg";